import React from 'react'
import Login from '../login/LoginPage'


const LoginView = () => {
  return (
    <div className='login-view'>
        <Login />
    </div>
  )
}

export default LoginView